import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import LocationServiceHero from '../components/locations/LocationServiceHero';
import ServiceFeatures from '../components/services/ServiceFeatures';
import NearbyAreas from '../components/locations/NearbyAreas';
import LocationServices from '../components/locations/LocationServices';
import ContactCTA from '../components/shared/ContactCTA';
import { capitalizeWords } from '../utils/stringUtils';
import { findService } from '../utils/serviceUtils';
import { generateLocationKeywords } from '../utils/seoKeywords';

export default function LocationService() {
  const { state, city, service: serviceId } = useParams();
  const service = serviceId ? findService(serviceId) : null;
  const formattedCity = capitalizeWords(city?.replace(/-/g, ' ') || '');
  const formattedState = capitalizeWords(state?.replace(/-/g, ' ') || '');

  // Generate location-specific title
  let locationTitle = formattedState;
  if (formattedCity) {
    locationTitle = `${formattedCity}, ${formattedState}`;
  }

  const title = `AC, Refrigerator, TV, Microwave, Washing Machine Service Center in ${locationTitle}`;

  const keywords = generateLocationKeywords({
    city: formattedCity,
    state: formattedState,
    service: service?.name
  });

  return (
    <>
      <Helmet>
        <title>{title} | Parakh Services</title>
        <meta 
          name="description" 
          content={`Professional appliance repair services in ${locationTitle}. Expert technicians, same-day service, and 90-day warranty.`} 
        />
        <meta name="keywords" content={keywords.join(', ')} />
      </Helmet>

      <LocationServiceHero 
        city={formattedCity} 
        state={formattedState}
        service={service}
        title={title}
      />

      {service ? (
        <ServiceFeatures service={service} />
      ) : (
        <LocationServices 
          city={formattedCity} 
          state={formattedState} 
          title={title}
        />
      )}

      <NearbyAreas city={formattedCity} state={formattedState} />
      <ContactCTA />
    </>
  );
}